import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

type PropsType = {
  debounceDuration: number;
};

export const useWindowDimensions = (props: PropsType) => {
  const { debounceDuration = 0 } = props;

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );

  useEffect(() => {
    const handleResize = () => {
      const newDimensions = getWindowDimensions();
      const hasChanged = windowDimensions !== newDimensions;

      if (hasChanged) {
        setWindowDimensions(newDimensions);
      }
    };

    const debounced = debounce(handleResize, debounceDuration);

    window.addEventListener('resize', debounced);
    return () => window.removeEventListener('resize', debounced);
  }, [windowDimensions, debounceDuration]);

  return windowDimensions;
};
